import dashoDorjiDhradhul from '@assets/dasho-dorji-dhradhul.png';
import logo from '@assets/logo.svg';
import { Box } from '@components/ui/atoms/Box';
import { Flex } from '@components/ui/atoms/Flex';
import { Image } from '@components/ui/atoms/Image';
import { Text } from '@components/ui/atoms/Text';
import { floatHover10, floatHover12Reverse, slideUpFade } from '@shared/utils/animationsUtil';
import React from 'react';

export const AuthQuoteCard: React.FC = () => (
  <Box position="relative" width="500px" flexShrink="0">
    <Box
      position="absolute"
      top="-30px"
      left="0"
      zIndex={0}
      opacity={0}
      animation={`${slideUpFade} 0.6s ease-out forwards 0.2s, ${floatHover12Reverse} 7s ease-in-out infinite 0.8s`}
    >
      <Box
        width="500px"
        height="280px"
        transform="rotate(-30deg)"
        bg="linear-gradient(117deg, rgba(246, 255, 254, 0.35) 9.03%, rgba(246, 251, 255, 0.20) 87.44%)"
        borderRadius="24px"
        backdropFilter="blur(15px)"
        boxShadow="0 2px 4px 0 rgba(255, 255, 255, 0.06) inset, 10px 10px 70px 0 rgba(80, 72, 166, 0.16)"
        display="flex"
        alignItems="flex-start"
        justifyContent="flex-end"
        padding="50px"
      >
        <Box>
          <Image src={logo} opacity={0.15} css={{ width: '32px', height: '27px' }} />
        </Box>
      </Box>
    </Box>

    <Flex
      position="relative"
      zIndex={1}
      w="500px"
      flexShrink="0"
      bg="linear-gradient(117deg, rgba(246, 255, 254, 0.35) 9.03%, rgba(246, 251, 255, 0.20) 87.44%)"
      borderRadius="24px"
      backdropFilter="blur(15px)"
      flexDir="column"
      boxShadow="0 2px 4px 0 rgba(255, 255, 255, 0.06) inset, 10px 10px 70px 0 rgba(80, 72, 166, 0.16)"
      opacity={0}
      animation={`${slideUpFade} 0.8s ease-out forwards, ${floatHover10} 6s ease-in-out infinite 0.8s`}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        alignItems="flex-start"
        gap="32px"
        padding="60px 50px"
      >
        <Text fontSize="20px" fontWeight="500" color="title.dark">
          &quot;Finally, a digital solution to uplift Bhutan as the world&apos;s premium and trusted
          luxury destination!&quot;
        </Text>
        <Flex display="flex" alignItems="center" gap="12px" flex="1 0 0" alignSelf="stretch">
          <Image
            src={dashoDorjiDhradhul}
            css={{ width: '40px', height: '40px', borderRadius: 'full' }}
            alt="Dasho Dorji Dhradhul"
          />
          <Flex flexDir="column">
            <Text fontWeight="600" fontSize="13px" color="title.dark">
              Dasho Dorji Dhradhul
            </Text>
            <Text fontSize="13px" fontWeight="400" color="body.dark">
              Former Director General, Department of Tourism
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  </Box>
);
